// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { PUT_SELECTED_COUNTRY_DATA_SUCCESS, RESET_SELECTED_COUNTRY_DATA } from './actions';
import { handleActions } from 'redux-actions';

export const INITIAL_STATE = {};

export type SelectedCountryStoreType = Readonly<typeof INITIAL_STATE>;

export function _putSelectedCountryCode(
    state: any,
    { payload }: { payload: any }
): SelectedCountryStoreType {
    if (payload) {
        return payload;
    }
    return state;
}

export default handleActions(
    {
        [PUT_SELECTED_COUNTRY_DATA_SUCCESS]: _putSelectedCountryCode,
        [RESET_SELECTED_COUNTRY_DATA]: () => INITIAL_STATE,
    },
    INITIAL_STATE
);
